type OrderReportGuardArgs = {
  isOrderReport: boolean;
  isLoadingQuickOrderFlags: boolean;
  managementOrderReportEnabled: boolean;
};

type ReportPermissionGuardArgs = OrderReportGuardArgs & {
  isManagementReport: boolean;
};

export const shouldBypassOrderReportPermission = ({
  isOrderReport,
  isLoadingQuickOrderFlags,
  managementOrderReportEnabled,
}: OrderReportGuardArgs) =>
  isOrderReport && (isLoadingQuickOrderFlags || managementOrderReportEnabled);

export const shouldBypassReportPermission = ({
  isManagementReport,
  isOrderReport,
  isLoadingQuickOrderFlags,
  managementOrderReportEnabled,
}: ReportPermissionGuardArgs) =>
  isManagementReport ||
  shouldBypassOrderReportPermission({
    isOrderReport,
    isLoadingQuickOrderFlags,
    managementOrderReportEnabled,
  });

export const shouldRedirectDisabledOrderReport = ({
  isOrderReport,
  isLoadingQuickOrderFlags,
  managementOrderReportEnabled,
}: OrderReportGuardArgs) =>
  isOrderReport && !isLoadingQuickOrderFlags && !managementOrderReportEnabled;
